/* custom-bv-write-review.js */

(() => {
  const CUSTOM_BUTTON_SELECTOR = '[data-bv-custom-write-review]';
  const ORIGINAL_BUTTON_SELECTOR = '.bv_war_button';
  const PRIMARY_CONTAINER_SELECTOR = '.bv_rating_content2';
  const FALLBACK_CONTAINER_SELECTOR = '.product-reviews-section';
  const REVIEW_COUNT_SELECTOR = '.bv_numReviews_text';
  const REVIEW_COUNT_BOUND_CLASS = 'bv-click-bound';
 // BV Critical Issue Fix: Start
  const FILTER_COMBOBOX_SELECTOR =
    '[role="combobox"][aria-controls^="bv-reviews-filter"], [role="combobox"][data-bv-aria-controls]';
  const STASHED_ARIA_CONTROLS_ATTR = 'data-bv-aria-controls';
// BV Critical Issue Fix: End

  const getOriginalButton = () => document.querySelector(ORIGINAL_BUTTON_SELECTOR);

  const getTargetContainer = () => {
    return (
      document.querySelector(PRIMARY_CONTAINER_SELECTOR) ||
      document.querySelector(FALLBACK_CONTAINER_SELECTOR)
    );
  };

  const createCustomButton = (originalButton) => {
    const button = document.createElement('button');
    button.type = 'button';
    button.textContent = 'Write a review';
    button.dataset.bvCustomWriteReview = 'true';
    button.dataset.item = 'button-3';

    button.addEventListener('click', (event) => {
      event.preventDefault();
      if (originalButton) {
        originalButton.click();
      }
    });

    return button;
  };

  const ensureCustomButton = () => {
    if (document.querySelector(CUSTOM_BUTTON_SELECTOR)) return true;

    const originalButton = getOriginalButton();
    const container = getTargetContainer();

    if (!originalButton || !container) return false;

    container.appendChild(createCustomButton(originalButton));
    return true;
  };

  // Scroll to the reviews section using getBoundingClientRect + pageYOffset —
  // the most reliable method on iOS Safari (scrollIntoView smooth is inconsistent)
  const scrollToReviews = () => {
    const target = document.querySelector(FALLBACK_CONTAINER_SELECTOR)
                || document.querySelector(PRIMARY_CONTAINER_SELECTOR);
    if (!target) return;
    window.scrollTo({ top: target.getBoundingClientRect().top + window.pageYOffset, behavior: 'smooth' });
  };

  // Stamp review-count elements with ARIA + cursor so iOS treats them as tappable.
  // Called by the MutationObserver each time BV re-renders.
  const stampReviewCountElements = () => {
    document.querySelectorAll(REVIEW_COUNT_SELECTOR).forEach((el) => {
      if (el.classList.contains(REVIEW_COUNT_BOUND_CLASS)) return;
      el.classList.add(REVIEW_COUNT_BOUND_CLASS);
      el.style.cursor = 'pointer';
      // a11y (nested-interactive): skip role/tabindex if already inside a button/link.
      if (!el.closest('button, [role="button"], a[href]')) {
        el.setAttribute('role', 'button');
        el.setAttribute('tabindex', '0');
      }
    });
  };
  // BV Critical Issue Fix: Start
  const reconcileFilterComboboxes = () => {
    document.querySelectorAll(FILTER_COMBOBOX_SELECTOR).forEach((el) => {
      const current = el.getAttribute('aria-controls');
      const id = current || el.getAttribute(STASHED_ARIA_CONTROLS_ATTR);
      if (!id) return;

      const listboxExists = document.getElementById(id) !== null;

      if (listboxExists && !current) {
        el.setAttribute('aria-controls', id);
        el.removeAttribute(STASHED_ARIA_CONTROLS_ATTR);
      } else if (!listboxExists && current) {
        el.setAttribute(STASHED_ARIA_CONTROLS_ATTR, id);
        el.removeAttribute('aria-controls');
      }
    });
  };
  // BV Critical Issue Fix: End

  // ── Document-level delegation ─────────────────────────────────────────────
  // Listening at the document root means:
  //  • We never need to re-bind after BV re-renders the widget.
  //  • BV's own element-level touchstart/touchend handlers cannot block us
  //    because we sit outside their capture scope.
  // ─────────────────────────────────────────────────────────────────────────

  let touchStartY = 0;
  // Timestamp prevents the 300 ms synthetic click (fired by iOS after touchend)
  // from triggering scrollToReviews a second time.
  let lastTouchHandledAt = 0;

  document.addEventListener('touchstart', (e) => {
    if (e.target.closest(REVIEW_COUNT_SELECTOR)) {
      touchStartY = e.touches[0].clientY;
    }
  }, { passive: true });

  document.addEventListener('touchend', (e) => {
    if (!e.target.closest(REVIEW_COUNT_SELECTOR)) return;
    const delta = Math.abs(e.changedTouches[0].clientY - touchStartY);
    // Only act on a genuine tap (finger moved < 10 px — not a scroll gesture)
    if (delta < 10) {
      lastTouchHandledAt = Date.now();
      scrollToReviews();
    }
  }, { passive: true });

  // Desktop / non-touch fallback; skipped when touchend already acted
  document.addEventListener('click', (e) => {
    if (!e.target.closest(REVIEW_COUNT_SELECTOR)) return;
    if (Date.now() - lastTouchHandledAt < 600) return;
    scrollToReviews();
  });

  // ── Init ──────────────────────────────────────────────────────────────────

  const init = () => {
    ensureCustomButton();
    stampReviewCountElements();
    // BV Critical Issue Fix: Start
    reconcileFilterComboboxes();
    // BV Critical Issue Fix: End

    // Watch for BV async renders / re-renders
    new MutationObserver(() => {
      ensureCustomButton();
      stampReviewCountElements();
      // BV Critical Issue Fix: Start
      reconcileFilterComboboxes();
      // BV Critical Issue Fix: End
    }).observe(document.body, { childList: true, subtree: true });
  };

  document.addEventListener('DOMContentLoaded', init);
})();
